module.exports = __webpack_public_path__ + "img/iOS_miaoshu.942f7048.png";